import * as React from 'react';
import type { RadarGridRenderProps } from './RadarGrid.types';

/**
 * @ignore - internal component.
 */
export function SharpRadarGrid(props: RadarGridRenderProps) {
  const { center, corners, divisions, strokeColor, classes } = props;

  const divisionRatio = Array.from({ length: divisions }, (_, index) => (index + 1) / divisions);

  return (
    <React.Fragment>
      {corners.map(({ x, y }, i) => (
        <path
          key={i}
          d={`M ${center.x} ${center.y} L ${x} ${y}`}
          stroke={strokeColor}
          strokeWidth={1}
          strokeOpacity={0.3}
          fill="none"
          className={classes?.gridRadial}
        />
      ))}
      {divisionRatio.map((ratio) => (
        <path
          key={ratio}
          d={`M ${corners
            .map(
              ({ x, y }) =>
                `${center.x * (1 - ratio) + ratio * x} ${center.y * (1 - ratio) + ratio * y}`,
            )
            .join(' L ')} Z`}
          stroke={strokeColor}
          strokeWidth={1}
          strokeOpacity={0.3}
          fill="none"
          className={classes?.gridDivider}
        />
      ))}
    </React.Fragment>
  );
}
